<template>
  <div style="width: 100%">
    <template v-if="type === 'pc'">
      <Header :nav-tree="navTree" :app-list="pageConfig.appList" :headerHighlight="headerHighlight" @showDialog="showDialog" />
      <UseDialog v-if="addUseDialog" ref="dialog" />
    </template>
    <template v-else-if="type === 'h5'">
      <MHeader :nav-tree="navTree" />
    </template>
  </div>
</template>
<script>
import pageConfig from '@/lib/pageConfig/index.js'
export default {
  props: {
    addUseDialog: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: 'pc',
    },
  },
  components: {
    Header: () => import('./Header.vue'),
    MHeader: () => import('./MHeader.vue'),
    UseDialog: () => import('../UseDialog.vue'),
  },
  data() {
    return {
      headerHighlight: false,
      pageConfig,
    }
  },
  computed: {
    navTree() {
      return pageConfig.navTree.filter(item => {
        return item.enable
      })
    },
  },
  methods: {
    showDialog() {
      if (this.addUseDialog) {
        this.$refs.dialog.showDialog()
      } else {
        this.$emit('showDialog')
      }
    },
    scrollHandle() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量

      if (scrollTop > 500) {
        // 导航背景高亮：透明度加到90%
        this.headerHighlight = true
      } else {
        // 导航背景高亮：透明度加到90%
        this.headerHighlight = false
      }
    },
  },
}
</script>
